export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname: 'div',
              name: "Colunas Diferenciais",
              attributes: { class: 'row-cubo' },
              components: [
                {
                  type: 'columnDifferences5',
                },
              ],
              styles: `
             .row-cubo{
                display: flex; 
                width:100%; 
             }
             @media (max-width:992px){
              .row-cubo{
                flex-direction:column;
              }
             }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};